var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5210_482194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.17065C1.33481 4.58249 0.5 5.69373 0.5 6.99995V16.9999C0.5 18.6568 1.84315 19.9999 3.5 19.9999H13.5C14.8067 19.9999 15.9182 19.1646 16.3297 17.9988H15.2331C14.8875 18.5972 14.2408 18.9999 13.5 18.9999H3.5C2.39543 18.9999 1.5 18.1045 1.5 16.9999V6.99995C1.5 6.25967 1.9022 5.61332 2.5 5.26751V4.17065Z",
    fill: "#1F85CF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#1F85CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2402 11.5129C11.1603 11.5126 11.0812 11.4959 11.0079 11.4638C10.9347 11.4317 10.8688 11.3849 10.8144 11.3262L7.97941 8.31039C7.87343 8.19745 7.81666 8.04704 7.82158 7.89224C7.82651 7.73745 7.89272 7.59095 8.00566 7.48497C8.1186 7.37899 8.26901 7.32222 8.4238 7.32715C8.5786 7.33207 8.7251 7.39828 8.83108 7.51122L11.2344 10.0721L16.1402 4.70539C16.19 4.64339 16.252 4.59223 16.3222 4.55504C16.3925 4.51785 16.4697 4.49542 16.5489 4.48913C16.6282 4.48284 16.7079 4.49282 16.7832 4.51846C16.8584 4.5441 16.9276 4.58485 16.9866 4.63821C17.0455 4.69158 17.0929 4.75643 17.1259 4.82879C17.1589 4.90114 17.1767 4.97947 17.1783 5.05897C17.1799 5.13846 17.1652 5.21744 17.1352 5.29106C17.1051 5.36468 17.0603 5.43137 17.0036 5.48705L11.6719 11.3204C11.618 11.3801 11.5524 11.428 11.4791 11.4611C11.4058 11.4943 11.3265 11.5119 11.2461 11.5129H11.2402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5210_482194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedAll);
export default __webpack_public_path__ + "static/media/CheckedAll.56b3f7d28002f6616055f5efa0853deb.svg";
export { ForwardRef as ReactComponent };